"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPerceptionAccount = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const EFinancialObjective_1 = require("../../enums/ProductSubscribed/EFinancialObjective");
const EFundsOrigin_1 = require("../../enums/ProductSubscribed/EFundsOrigin");
const ECommunityInvestment_1 = require("../../enums/Subscription/ECommunityInvestment");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
const SubscriptionBankDetailsResource_1 = __importDefault(require("./SubscriptionBankDetailsResource"));
const CommunitySpouseDetailsCreateRequestResource_1 = __importDefault(require("./CommunitySpouseDetails/CommunitySpouseDetailsCreateRequestResource"));
const ESubscriptionType_1 = require("../../enums/Subscription/ESubscriptionType");
const EFundsOriginCorporation_1 = require("../../enums/ProductSubscribed/EFundsOriginCorporation");
const ECountry_1 = require("../../enums/Country/ECountry");
const EFundsOriginCommunityInvestment_1 = require("../../enums/Subscription/EFundsOriginCommunityInvestment");
var SubscriptionBankDetailsResource_2 = require("./SubscriptionBankDetailsResource");
Object.defineProperty(exports, "hasPerceptionAccount", { enumerable: true, get: function () { return SubscriptionBankDetailsResource_2.hasPerceptionAccount; } });
class SubscriptionUpdateRequestResource extends SubscriptionBankDetailsResource_1.default {
    constructor() {
        super(...arguments);
        this.paymentFromCountry = null;
    }
}
exports.default = SubscriptionUpdateRequestResource;
__decorate([
    (0, CustomAsync_1.default)((id) => Di_1.default.getSuscriptionService().exists(id), {
        message: ValidationErrors_1.EValidationError.subscriptionNotExists,
    }),
    (0, class_validator_1.IsUUID)(4),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SubscriptionUpdateRequestResource.prototype, "subscriptionId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsEnum)(EFundsOrigin_1.EFundsOrigin, { each: true }),
    (0, class_validator_1.ValidateIf)((obj) => obj.fundsOriginCorporation.length === 0),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SubscriptionUpdateRequestResource.prototype, "fundsOrigin", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsEnum)(EFundsOriginCorporation_1.EFundsOriginCorporation, { each: true }),
    (0, class_validator_1.ValidateIf)((obj) => obj.fundsOrigin.length === 0),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SubscriptionUpdateRequestResource.prototype, "fundsOriginCorporation", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(120, { context: [120] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "signaturePlace", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.fundsOrigin.some((fundsOrigin) => fundsOrigin === EFundsOrigin_1.EFundsOrigin.other) ||
        obj.fundsOriginCorporation.some((fundsOrigin) => fundsOrigin === EFundsOriginCorporation_1.EFundsOriginCorporation.other)),
    (0, class_validator_1.MaxLength)(120, { context: [120] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "fundsOriginOther", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.fundsOrigin.some((fundsOrigin) => fundsOrigin === EFundsOrigin_1.EFundsOrigin.savings) ||
        obj.fundsOriginCorporation.some((fundsOrigin) => fundsOrigin === EFundsOriginCorporation_1.EFundsOriginCorporation.epargne)),
    (0, class_validator_1.MaxLength)(120, { context: [120] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "fundsOriginSavings", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.fundsOriginCorporation.some((fundsOrigin) => fundsOrigin === EFundsOriginCorporation_1.EFundsOriginCorporation.apport_compte_courant)),
    (0, class_validator_1.MaxLength)(120, { context: [120] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "apportCompteCourant", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsEnum)(EFinancialObjective_1.EFinancialObjective, { each: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], SubscriptionUpdateRequestResource.prototype, "financialObjective", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], SubscriptionUpdateRequestResource.prototype, "isRegimeMatrimonialCommunity", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ESubscriptionType_1.ESubscriptionType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SubscriptionUpdateRequestResource.prototype, "subscriptionType", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (!obj.isRegimeMatrimonialCommunity) {
            obj.communityInvestment = null;
        }
        return obj.isRegimeMatrimonialCommunity;
    }),
    (0, class_validator_1.IsEnum)(ECommunityInvestment_1.ECommunityInvestment),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "communityInvestment", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.communityInvestment !== ECommunityInvestment_1.ECommunityInvestment.reinvestment_of_equity) {
            obj.fundsOriginCommunityInvestment = null;
        }
        return obj.communityInvestment === ECommunityInvestment_1.ECommunityInvestment.reinvestment_of_equity;
    }),
    (0, class_validator_1.IsEnum)(EFundsOriginCommunityInvestment_1.EFundsOriginCommunityInvestment),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "fundsOriginCommunityInvestment", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        if (obj.fundsOriginCommunityInvestment !== EFundsOriginCommunityInvestment_1.EFundsOriginCommunityInvestment.other) {
            obj.fundsOriginCommunityInvestmentOther = null;
        }
        return obj.fundsOriginCommunityInvestment === EFundsOriginCommunityInvestment_1.EFundsOriginCommunityInvestment.other;
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "fundsOriginCommunityInvestmentOther", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => {
        const condition = obj.isRegimeMatrimonialCommunity && obj.subscriptionType === ESubscriptionType_1.ESubscriptionType.naturalPerson;
        if (!condition) {
            obj.communitySpouseDetails = null;
        }
        return condition;
    }),
    (0, class_transformer_1.Type)(() => CommunitySpouseDetailsCreateRequestResource_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "communitySpouseDetails", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "paymentFromFrenchAccount", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((obj) => !obj.paymentFromFrenchAccount),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "paymentFromCountry", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "paymentByTier", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(120, { context: [120] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((obj) => obj.paymentByTier === true),
    __metadata("design:type", Object)
], SubscriptionUpdateRequestResource.prototype, "paymentByTierMotive", void 0);
